import * as React from 'react';
import Input from './Input';

interface FiltersProps {
  textFilter: (searchQuery: string) => void;
  brandFilter: (brand: string) => void;
  marketingMaterialFilter: (value: string) => void;
  productsFilter: (value: boolean) => void;
  marketingMaterialFilters: Array<MarketingFilter>;
  brands: Array<string>;
  company: string;
}

interface FiltersState {
  brandFilter: string;
  marketingMaterialFilter: string;
  productsFilter: boolean;
}

interface MarketingFilter {
  name: string;
  id: string;
}

class Filters extends React.Component<FiltersProps, FiltersState> {
  constructor(props: FiltersProps) {
    super(props);
    this.state = {
      brandFilter: '',
      marketingMaterialFilter: '',
      productsFilter: false,
    };
  }

  componentWillReceiveProps(newProps: FiltersProps) {
    if (this.props.company !== newProps.company) {
      this.onChangeBrandFilter('');
    }
  }

  onChangeBrandFilter(brand: string) {
    this.props.brandFilter(brand);
    this.setState({ brandFilter: brand });
  }

  isActiveBrand(brand: string): boolean {
    return this.state.brandFilter === brand;
  }

  isProductsActive() {
    return this.state.productsFilter;
  }

  onProductFilterClick() {
    if (this.state.marketingMaterialFilter !== '') {
      this.onMarketingFilterClick(this.state.marketingMaterialFilter);
    }

    const status = !this.state.productsFilter;

    this.props.productsFilter(status);
    this.setState({ productsFilter: status });
  }

  isMarketingActive(material: string) {
    return this.state.marketingMaterialFilter === material;
  }

  onMarketingFilterClick(material: string) {
    if (this.state.productsFilter) {
      this.onProductFilterClick();
    }

    if (this.state.marketingMaterialFilter === material) {
      material = '';
    }
    this.props.marketingMaterialFilter(material);
    this.setState({ marketingMaterialFilter: material });
  }

  render() {
    const { textFilter, brandFilter, brands, marketingMaterialFilters } =
      this.props;

    return (
      <div className="filters condensed">
        <div className="filters__text">
          <label htmlFor="textsearch">Tekstihaku</label>
          <Input
            type={'text'}
            id={'textsearch'}
            placeholder={'Hae tekstistä...'}
            onChange={(value) => textFilter(value)}
          />
        </div>
        <div className="filters__marketing">
          <div
            className={this.isProductsActive() ? 'filter active' : 'filter'}
            onClick={() => this.onProductFilterClick()}
          >
            Tuotteet
          </div>
          {marketingMaterialFilters.map((material, index) => (
            <div
              key={index}
              className={
                this.isMarketingActive(material.id) ? 'filter active' : 'filter'
              }
              onClick={() => this.onMarketingFilterClick(material.id)}
            >
              {material.name}
            </div>
          ))}
        </div>
        <div className="filters__product">
          <div
            className={this.isActiveBrand('') ? 'filter active' : 'filter'}
            onClick={() => this.onChangeBrandFilter('')}
          >
            Kaikki
          </div>
          {brands.map((brand, index) => (
            <div
              key={index}
              className={this.isActiveBrand(brand) ? 'filter active' : 'filter'}
              onClick={() => this.onChangeBrandFilter(brand)}
            >
              {brand}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Filters.tsx